import Overlay from "./Overlay";

// content while loading the page
const LoadingOverlay = ({headline}) => (
  <Overlay>
    <h1 className="headline">{headline}</h1>
  </Overlay>
);

export default LoadingOverlay